const t = {
  postV1TransactionsIdAccept: {
    schema: {
      method: "post",
      url: "/v1/transactions/{id}/accept",
      mediaType: "application/json"
    }
  },
  postV1TransactionsIdRefuse: {
    schema: {
      method: "post",
      url: "/v1/transactions/{id}/refuse",
      mediaType: "application/json"
    }
  },
  getV1Transactions: {
    schema: {
      method: "get",
      url: "/v1/transactions"
    }
  },
  getV1TransactionsId: {
    schema: {
      method: "get",
      url: "/v1/transactions/{id}"
    }
  }
};
export {
  t as v1Service
};
